import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const ENDPOINT = (id: number | string) => `${API_URL}/api/energy/rooms/${id}`

const convertDate = (current_time: Date): string => current_time.toISOString()

const fetchRoomStats = (access_token: string, id: number | string, current_time: Date) => Axios.get(ENDPOINT(id), {
  params: { current_time: convertDate(current_time) },
  headers: {
    'Access-Token': access_token,
  },
})

export default {
  fetchRoomStats,
}
